import Products from 'Resources/Product';
import { isAvailable, Feature } from 'App/services/FeatureHelperStandalone';
import AppService from 'App/legacy/AppService';

export const getRecurringProducts = productIds => {
	if (
		!(
			isAvailable(Feature.RECURRING_ORDER) &&
			AppService.getMetadata().params.AgreementEnabled
		)
	) {
		return Promise.resolve([]);
	}
	if (AppService.getTotals('products') < 4000) {
		return Promise.resolve(
			_.filter(AppService.getProducts(), product =>
				productIds ? product.isRecurring && productIds.includes(product.id) : product.isRecurring
			)
		);
	} else {
		const filter = {
			isRecurring: true,
			id: productIds ? productIds : [],
			sort: 'id'
		};
		return Products.findAll(filter).catch(function (err) {
			console.log('Error getting products: ', err);
			return [];
		});
	}
};

export const hasRecurringProduct = order => {
	if (
		!(
			isAvailable(Feature.RECURRING_ORDER) &&
			AppService.getMetadata().params.AgreementEnabled
		)
	) {
		return Promise.resolve(false);
	}

	return getRecurringProducts().then(function (recurringProducts) {
		return _.some(order.orderRow, function (row) {
			return _.some(recurringProducts, { id: row.product.id });
		});
	});
};
